import { Injectable } from '@angular/core';
import { MESSAGE } from '@core/constants/api.constants';
import { Message } from '@shared/models/message.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from '../http/http-api';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(
    private httpService: HttpService
  ) { }

  public messageCount$: BehaviorSubject<number> = new BehaviorSubject(0)
  public messages$: BehaviorSubject<any> = new BehaviorSubject(null);

  getMessageCounts(): Observable<number>{
    return this.messageCount$.asObservable();
  }

  setMessageCount(value: number){
    this.messageCount$.next(value);
  }

  getMessage(): Observable<any>{
    return this.messages$.asObservable();
  }

  setMessages(value: any){
    this.messages$.next(value);
  }

  async getMessageCount(): Promise<any> {
    this.httpService.get(MESSAGE.GET_COUNT, undefined, {'skip': true}).then(result => {
      this.setMessageCount(result);
    });
  }

  async getAllMessages() {
    let params = {
      offset: 0,
      limit: -1,
      sortBy: 'id:desc',
      subject: ''
    }
    
    return this.httpService.get(MESSAGE.GET, params)
  }


  async getMessages(offset: number, limit: number, sortBy?: string, subject?: string) {
    let params: any | null = {}

    if (limit != -1) { params.limit = limit; params.offset = offset }
    if (sortBy) { params.sortBy = sortBy }
    if (subject) { params.subject = subject }
    
    this.httpService.get(MESSAGE.GET, params).then(result => {
      this.setMessages(result);
    });
  }

  async modifyMessageStatus(messageId: string, body: object) {
    
    return this.httpService.put(MESSAGE.PUT(messageId), body);
  }

  async modifyMessagesStatus(messageIds: Array<string>, body: Array<object>) {
    let strMessageIds = messageIds.join(',');

    return this.httpService.post(MESSAGE.POST(strMessageIds), body);
  }

  async deleteMessages(messageIds: Array<string>) {
    let messageIdsStr = messageIds.join(',');
    
    return this.httpService.delete(MESSAGE.DELETE(messageIdsStr));
  }
}
